import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const storyblok = defineConnector({
  identifier: "storyblok",
  name: "Storyblok",
  tagLine: "Headless CMS",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: () => "https://mapi\\.storyblok\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Storyblok](https://app.storyblok.com/), go to **Settings → Access Tokens** to generate a personal access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://mapi.storyblok.com/v1/spaces/",
  },
});
